import {Component, inject, Inject, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {ApplicationService, Page} from "../services/application.service";
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute, NavigationEnd, NavigationStart, Router} from "@angular/router";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {LoadingComponent} from "../modals/loading/loading.component";
import {FileUploadServiceService} from "../services/file-upload-service.service";
import {filter, finalize, map, tap} from "rxjs/operators";
import {Observable} from 'rxjs';
import {ToastService} from '@shared/services/toast.service';
import {cloneDeep} from 'es-toolkit';

@Component({
  selector: 'app-dynamic-input-form',
  templateUrl: './dynamic-input-form.component.html',
  styleUrls: ['./dynamic-input-form.component.scss'],
  standalone: false
})
export class DynamicInputFormComponent implements OnInit, OnChanges {
  currentPage: Page;
  previousPage: Page;
  nextPage: Page;
  currentItem: string;
  currentAttributes: any;
  currentMeta: any;
  help: any;
  @Input() helpPromise: Promise<any>;
  toastService = inject(ToastService);

  constructor(public application: ApplicationService,
              private http: HttpClient,
              public route: ActivatedRoute,
              private router: Router,
              private modalService: NgbModal,
              public fileUploadService: FileUploadServiceService,
              @Inject('environment') private environment
  ) {
  }

  ngOnInit(): void {
    this.route.params.pipe(
      // filter(e => e instanceof NavigationEnd),
      tap(params => {
        this.loadPage(params.route);
      })
    ).subscribe()
  }

  ngOnChanges(changes: SimpleChanges) {
    // todo: check if actual changes occurred then call page onItemChange
    if ('onItemChange' in this.currentPage) {
      this.currentPage.onItemChange(this.currentItem, this.currentPage)
    }
  }

  private loadPage(route) {
    this.application.pages.subscribe(pages => {
      this.currentPage = pages.find(x => x.item === route);
      this.currentPage.canActivate = true;
      this.currentItem = this.currentPage.item;
      this.application.activePage.next(this.currentItem);
      this.currentAttributes = this.application.getPageAttributes(this.currentPage);
      this.currentMeta = this.application.getPageMeta(this.currentPage);
      this.previousPage = pages.find(p => p.order === this.currentPage.order - 1)
      this.nextPage = pages.find(p => p.order === this.currentPage.order + 1);
      this.scrollToFirstInput();
    })

  }

  public validate(e) {
    // blur next button to prevent issue with page scrolling to button on route change
    e.currentTarget.blur();
    const modalInstance = this.modalService.open(LoadingComponent, {backdrop: 'static'});
    modalInstance.componentInstance.message = 'Validating Current Page';

    this.application.validate(this.currentPage, this.currentAttributes).pipe(
      tap(() => {
        this.router.navigate(['application', this.route.parent.snapshot.params.type, this.nextPage.item]);
      }),
      finalize(() => setTimeout(() => modalInstance.close(), 750))
    ).subscribe();
  };

  public addObject(array) {
    if (this.application.meta.fields[this.currentItem].child.fields.hasOwnProperty('shape')) {
      array.push({shape: {}, coordinates: {}});
    } else {
      array.push({});
    }
  };

  // clearEmissionsFactor(item) {
  //   delete item.toc_units;
  //   delete item.pm_units;
  //   delete item.so2_units;
  //   delete item.co_units;
  //   delete item.no_units;
  //   // delete item.haps_units;
  //   delete item.benzene_units;
  //   // delete item.formaldehyde_units;
  //   delete item.carbon_dioxide_units;
  //   delete item.nitrous_oxide_units;
  //   delete item.methane_units;
  //
  //   item.total_unburned_hydrocarbons = null;
  //
  //   item.particulate_matter = null;
  //   // item.pm_units = undefined;
  //   item.sulfur_dioxide = null;
  //   // item.so1_units = undefined;
  //   item.carbon_monoxide = null;
  //   // item.co_units = undefined;
  //   item.nitrogen_oxide = null;
  //   // item.no_units = undefined;
  //   // item.hazardous_air_pollutants = null;
  //   // item.haps_units = undefined;
  //   item.benzene = null;
  //   // item.formaldehyde = null;
  //   item.carbon_dioxide = null;
  //   item.nitrous_oxide = null;
  //   item.methane = null;
  // };

  public remove(items, index) {
    if (this.application.attributes[this.currentPage.item][index].globalid) {
      this.currentPage.service.delete(this.application.attributes[this.currentPage.item][index].globalid).subscribe(
        () => {
          this.toastService.success('Success');
          this.application.attributes[this.currentPage.item].splice(index, 1)
        },
        error => {
          this.toastService.error(error.error.details);
          console.error('Error removing item:', error);
          // Optionally, you can show an error message to the user
        }
      )
    } else {

      this.application.attributes[this.currentPage.item].splice(index, 1);
    }

  };

  public isArray(x): boolean {
    return Array.isArray(x);
  }

  public setMeta(item, meta, multi = true) {
    if (item?._meta === undefined && multi) {
      item._meta = cloneDeep(meta);
      // set up display_fields and add to item._meta for each item "form group" (ie each contact in the array)
      this.currentPage.onItemChange(item, this.currentPage);
    } else {
      this.currentPage.onItemChange(item, this.currentPage, meta);
    }
  }

  private scrollToFirstInput() {
    console.log('scrollToFirst', document.querySelectorAll('app-dynamic-input'));
  }
}
